import Calendar from "@fuse/assets/images/legacy/img-calendar.png"
import Lightning from "@fuse/assets/images/legacy/img-lightning.svg"
import People from "@fuse/assets/images/legacy/img-people.svg"
import TextBubble from "@fuse/assets/images/legacy/img-text-bubble.svg"

export const Content = [
  {
    img: People,
    heading: "Authentic circles",
    content: "Deepen bonds with friends and expand your social circle.",
  },
  {
    img: TextBubble,
    heading: "No group chat chaos",
    content:
      "Clear chat, centered on activities, fostering meaningful connections.",
  },
  {
    img: Calendar,
    heading: "Activity",
    content:
      "Plan and organize events effortlessly. Stay on top of group activities.",
  },
  {
    img: Lightning,
    heading: "A Freemium promise",
    content:
      "Experience the best for free, everyone deserves to feel connected.",
  },
]
